import React from 'react';
import { Wysiwyg } from '../../Wysiwyg';
import { PostReply } from '../Post.types';
import bem from '../../../../lib/bemUtils/bem';

export function PostBubble({
  model,
  modifier,
  smallText,
  verySmallPadding,
}: {
  model: PostReply;
  modifier?: 'round' | 'small-margin-bottom' | string[];
  smallText?: boolean;
  verySmallPadding?: boolean;
}) {
  const getWysiwygModifier = () => {
    const wysiwygModifier = ['small-padding']; // default
    if (smallText) {
      wysiwygModifier.push('small-text');
    }
    if (verySmallPadding) {
      wysiwygModifier.push('very-small-padding');
    }
    return wysiwygModifier;
  };
  return (
    <div className={bem('posts__bubble', modifier)}>
      <Wysiwyg
        content={model.content}
        modifier={getWysiwygModifier()}
        resourceReferencesToToUrls={model.resourceReferencesToToUrls}
      />
    </div>
  );
}
